function getScripts(scripts = []) {
    // Load JS files synchonously
    let script = scripts.shift();
    if (script != null) {
        let scriptEl = document.createElement('script');
        document.body.appendChild(scriptEl);
        if (script.src != null) {
            let scriptNode = document.querySelector(`script[src="${script.src}"]`);
            if( scriptNode != null) {
                scriptNode.remove();            
            }
            scriptEl.addEventListener('load', (event) => {
                getScripts(scripts);
            })
            //console.log("[CommentsDrawer Middleware] src:",script.src);
            scriptEl.src = script.src;
        }
        else {
            try {
                //console.log("[CommentsDrawer Middleware] eval script:",script.innerHTML);
                eval.call(window, script.innerHTML);
            } catch (e) {
                console.warn("[CommentsDrawer] Eval Error Caught:\n", e);
            }
            getScripts(scripts);
        }

    }

}

function loadScripts(container) {
    let scripts = [];
    [...container.querySelectorAll('script')].forEach((scriptEl, index) => {
        const src = scriptEl.getAttribute('src');
        let script = {
            src: src,
            innerHTML: scriptEl.innerHTML
        }
        scripts.push(script);
    })
    getScripts( scripts);
    
}

export default loadScripts;